<template>
  <div class="calculate-content" id="app">
    <!-- 顶部固定栏 -->
    <!-- <div class="calculate-title-line-input">
        <div class="title-line-input-text">结婚预算</div>
    </div>-->
    <div class="calculate-backgroud">
      <div class="calculate-img"></div>
    </div>
    <!-- 预算金额输入框 -->
    <div class="calculate-bottom">
      <div class="calculate-text">预算总额</div>
      <span v-if="isUnitShow" :style="{marginLeft:unitsMarginLeft}" class="amount-units">{{units}}</span>
      <input
        class="calculate-input"
        type="tel"
        maxlength="8"
        @blur="inputBlur()"
        @focus="inputFocus()"
        @input="handleInput()"
        :placeholder="plc"
        v-model="budgetPrice"
      />
      <div class="border-line"></div>
      <!-- 开始计算按钮 -->
      <img src="../../../assets/redShadow.png" class="input-shadow-area-calculate" />
      <div
        :class=" budgetPrice >= 20000 ? 'calculate-btn' : 'calculate-btn-diabled' "
        @click="calculate()"
      >开始计算</div>
      <div class="calculate-blank"></div>
      <!-- 信息提示弹窗 -->
      <div v-if="popShow" class="calculate-message-pop">{{ popMessage }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import GLOBAL from '../../../components/jiri/Global'
import callapp from 'callapp'
export default {
  beforeMount() {},
  mounted() {
    var that = this
    // 设置标题
    document.title = '结婚预算'

    // 获取token和城市ID
    that.getTokenAndCity()
    callapp('uiCloseBtn', { hide: 'true' })
    //wap登录跳转携带已输入的金额值
    that.budgetPrice = GLOBAL.getUrlParam('budgetTotalAmount')
    //数据上报
    window.$action = new postdata({ 
      appkey: 'hunbasha_wap',
      pageName:location.pathname,
      sensor_option:{
        openAll:true
      }
    })
  },
  data() {
    return {
      plc: '请输入',
      budgetPrice: '', // 预算金额
      isFocus: false, // 是否光标在输入框内 false:不在 true：在
      popShow: false, // 信息提示弹窗是否显示 true：显示 false：隐藏
      popMessage: '', // 信息提示框显示内容
      cityId: 0, // 城市ID
      token: '', // token
      units: '', //单位
      isUnitShow: false,
      unitsMarginLeft: ''
    }
  },
  methods: {
    /**
     * 输入框只能输入数字
     */
    handleInput() {
      var that = this
      that.budgetPrice = that.budgetPrice.replace(/[^\d]/g, '')
      if (!that.budgetPrice) {
        that.plc = '请输入'
      }

      var is_ios = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      console.log('is_ios',is_ios)
      if (is_ios) {
        if (that.budgetPrice.length < 4) {
          that.isUnitShow = false
        } else if (that.budgetPrice.length == 4) {
          that.isUnitShow = true
          that.units = '千'
          that.unitsMarginLeft = '25.1rem'
        } else if (that.budgetPrice.length == 5) {
          that.units = '万'
          that.unitsMarginLeft = '23.7rem'
        } else if (that.budgetPrice.length == 6) {
          that.units = '十万'
          that.unitsMarginLeft = '22.2rem'
        } else if (that.budgetPrice.length == 7) {
          that.units = '百万'
          that.unitsMarginLeft = '20.8rem'
        } else if (that.budgetPrice.length == 8) {
          that.units = '千万'
          that.unitsMarginLeft = '19.35rem'
        }
      } else {
        if (that.budgetPrice.length < 4) {
          that.isUnitShow = false
        } else if (that.budgetPrice.length == 4) {
          that.isUnitShow = true
          that.units = '千'
          that.unitsMarginLeft = '24.9rem'
        } else if (that.budgetPrice.length == 5) {
          that.units = '万'
          that.unitsMarginLeft = '23.2rem'
        } else if (that.budgetPrice.length == 6) {
          that.units = '十万'
          that.unitsMarginLeft = '21.5rem'
        } else if (that.budgetPrice.length == 7) {
          that.units = '百万'
          that.unitsMarginLeft = '19.85rem'
        } else if (that.budgetPrice.length == 8) {
          that.units = '千万'
          that.unitsMarginLeft = '18.2rem'
        }
      }
    },

    /**
     * 输入框光标离开事件
     */
    inputBlur() {
      var that = this
      that.isFocus = false
      that.plc = '请输入'
    },
    /**
     * 输入框光标进入事件
     */
    inputFocus() {
      var that = this
      that.isFocus = true
      // window.scroll(0, 0)
      that.plc = '请输入'
    },
    /**
     * 计算预算事件
     */
    calculate() {
      this.postData('budget_start')
      var that = this
      // 预算总额最低20000
      if (!that.budgetPrice || that.budgetPrice < 20000) {
        that.popShow = true
        that.popMessage = '预算总额最低2万元哦'
        setTimeout(that.closePop, 2000)
        return
      }

      if (that.budgetPrice.length > 8) {
        ;(that.popShow = true), (that.popMessage = '预算总额要小于1亿元哦')
        setTimeout(that.closePop, 2000)
        return
      }
      that.isUnitShow = false
      //直接取cookie用户信息  防止页面清缓存后操作
      if (!GLOBAL.getCookie('Authorization')) {
        GLOBAL.h5Login(
          location.protocol +
            '//' +
            location.host +
            '/budget/index?budgetTotalAmount=' +
            that.budgetPrice
        )
        return
      }

      // 后台API请求参数
      let requestData = {
        budgetTotalAmount: that.budgetPrice
      }
      // 计算预算相关明细信息
      axios
        .post(GLOBAL.getUrlDomainForBudget() + 'calculateBudget', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(function(response) {
          var code = response.data.code
          // 成功
          if (code === 0) {
            // 跳转至结婚预算明细页面
            location.assign('detail.html')
          } else {
            that.popShow = true
            that.popMessage = response.data.message
            setTimeout(that.closePop, 2000)
            return
          }
        })
        .catch(function() {})
    },
    /**
     * 关闭信息提示弹窗
     */
    closePop() {
      var that = this
      that.popShow = false
      that.popMessage = ''
    },
    /**
     * 获取token和城市ID
     */
    getTokenAndCity() {
      var that = this
      // 城市ID
      that.cityId = GLOBAL.getCookie('city-id')
      // token
      that.token = GLOBAL.getCookie('Authorization')
    },
    postData(acName, url) {
      //事件日志上报
      let params = {
        actionName: acName,
        actionValue: url
      }
      window.$action.h_actionDatas(params)
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
}
#app {
  position: absolute;
  top: 0;
  left: 0;
}
/* 主div */
.calculate-content {
  width: 100%;
  height: 100%;
  /* text-align: center; */
  background-color: white;
  position: relative;
}

.calculate-backgroud {
  width: 100%;
  height: 36.6rem;
  background-color: #ffe9dd;
  position: absolute;
}

.calculate-img {
  top: -6.4rem;
  width: 100%;
  height: 36.6rem;
  background-image: url('https://img.hbhcdn.com/dmp/other/1583596800/jh-img-orig-ga_1236543090139234304_1125_1125_409566.png');
  background-repeat: no-repeat;
  background-size: 100% 36.6rem;
  -moz-background-size: 100% 36.6rem;
  position: absolute;
}

.calculate-bottom {
  width: 37.5rem;
  height: 28rem;
  background: rgba(255, 255, 255, 1);
  /* box-shadow: 0rem 0rem 1.5rem 0rem rgba(252, 191, 137, 0.3); */
  border-radius: 2rem 2rem 0rem 0rem;
  position: absolute;
  top: 32.3rem;
}

.calculate-blank {
  width: 100%;
  height: 2rem;
}

.input-shadow-area {
  width: 29.3rem;
  height: 8.6rem;
  margin-top: 2.25rem;
  margin-left: 4.25rem;
  z-index: 1;
  position: absolute;
}

.input-shadow-area-calculate {
  width: 29.3rem;
  height: 8.6rem;
  margin-top: 10.25rem;
  margin-left: 4.25rem;
  position: absolute;
  z-index: 1;
}
.border-line {
  width: 25rem;
  height: 0.05rem;
  background: rgba(238, 238, 238, 1);
  position: absolute;
  margin-top: 8.8rem;
  margin-left: 6.25rem;
  z-index: 3;
}

.calculate-text {
  width: 6.4rem;
  height: 2.2rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
  z-index: 3;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
  font-weight: 9rem;
  color: rgba(51, 51, 51, 1);
  margin-top: 5.25rem;
  margin-left: 6.25rem;
  position: absolute;
}

.calculate-input {
  width: 15rem;
  height: 2.8rem;
  min-height: 2.8rem !important;
  min-width: 15rem !important;
  background-color: white;
  outline: none !important;
  border: 0rem;
  padding: 0rem !important;
  color: #ff3b50;
  font-family: 'DINAlternate-Bold', 'DINAlternate';
  letter-spacing: 3px;
  text-align: right;
  font-size: 2.4rem;
  font-weight: bold;
  margin-top: 4.95rem;
  right: 6.25rem;
  position: absolute;
}

.back-ground {
  background-color: #f3f3f3 !important;
}

.calculate-btn {
  width: 25rem;
  height: 5rem;
  border-radius: 2.5rem;
  background: linear-gradient(
    90deg,
    rgba(255, 59, 80, 1) 0%,
    rgba(255, 85, 66, 1) 100%
  );
  box-shadow: 0rem 0rem 1rem 0rem rgba(255, 59, 80, 0.4);
  color: #ffffff;
  font-size: 'PingFangSC-Regular';
  text-align: center;
  line-height: 5rem;
  font-size: 1.6rem;
  position: absolute;
  left: 6.25rem;
  margin-top: 12rem;
  z-index: 2;
}

.calculate-btn-diabled {
  width: 25rem;
  height: 5rem;
  border-radius: 2.5rem;
  background: linear-gradient(
    90deg,
    rgba(255, 59, 80, 1) 0%,
    rgba(255, 85, 66, 1) 100%
  );
  box-shadow: 0rem 0rem 1rem 0rem rgba(255, 59, 80, 0.4);
  color: #ffffff;
  font-size: 'PingFangSC-Regular';
  text-align: center;
  line-height: 5rem;
  font-size: 1.6rem;
  opacity: 0.5;
  position: absolute;
  left: 6.25rem;
  margin-top: 12rem;
  z-index: 2;
}

.calculate-message-pop {
  width: 20.5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.6rem;
  position: fixed;
  top: 21.5rem;
  left: 8.5rem;
  opacity: 0.9;
  background-color: #333333;
  z-index: 999;
}

.amount-units {
  width: 2.5rem;
  height: 1.4rem;
  font-size: 1.1rem;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
  color: rgba(153, 153, 153, 1);
  line-height: 1.4rem;
  position: absolute;
  margin-top: 3.7rem;
}

input::-webkit-input-placeholder {
  font-size: 1.6rem;
  color: #999999;
  letter-spacing: 0px;
  font-weight: 400;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 1.6rem;
  color: #999999;
  letter-spacing: 0px;
  font-weight: 400;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 1.6rem;
  color: #999999;
  letter-spacing: 0px;
  font-weight: 400;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 1.6rem;
  color: #999999;
  letter-spacing: 0px;
  font-weight: 400;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
}
</style>
